import { render, staticRenderFns } from "./ucl-quiz-success.vue?vue&type=template&id=dc6a06b6"
import script from "./ucl-quiz-success.vue?vue&type=script&setup=true&lang=js"
export * from "./ucl-quiz-success.vue?vue&type=script&setup=true&lang=js"
import style0 from "@ui-common/vue-feedback/dist/vue-feedback.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports